import { render, staticRenderFns } from "./AppFormMultipleActions.vue?vue&type=template&id=72cbd4e4&"
import script from "./AppFormMultipleActions.vue?vue&type=script&lang=js&"
export * from "./AppFormMultipleActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports